export const translations = {
  // Invitation Card
  invitationTitle: {
    en: "You are cordially invited to the wedding of",
    bn: "আপনাকে আন্তরিকভাবে আমন্ত্রণ জানানো হচ্ছে"
  },
  coupleNames: {
    en: "Anica & Tamjid",
    bn: "আনিকা ও তামজিদ"
  },
  openInvitation: {
    en: "Open Invitation",
    bn: "আমন্ত্রণপত্র খুলুন"
  },

  // RSVP CTA Button
  rsvpCta: {
    en: "RSVP Now",
    bn: "এখনই RSVP করুন"
  },
  rsvpCtaSubtext: {
    en: "Let us know if you can make it!",
    bn: "আপনি আসতে পারবেন কিনা জানান!"
  },

  // Language Toggle
  english: {
    en: "English",
    bn: "English"
  },
  bangla: {
    en: "বাংলা",
    bn: "বাংলা"
  },

  // Hero Section
  heroTitle: {
    en: "Anica & Tamjid are Getting Married",
    bn: "আনিকা ও তামজিদের বিবাহ সমারোহ"
  },
  heroSubtitle: {
    en: "August 16, 2026",
    bn: "১৬ আগস্ট ২০২৬"
  },
  weddingDate: {
    en: "August 16, 2026",
    bn: "১৬ আগস্ট ২০২৬"
  },

  // Navigation / Sections
  navHome: {
    en: "Home",
    bn: "হোম"
  },
  navDetails: {
    en: "Details",
    bn: "বিবরণ"
  },
  navDressCode: {
    en: "Suggested Attire",
    bn: "প্রস্তাবিত পোশাক"
  },
  navRsvp: {
    en: "RSVP",
    bn: "আরএসভিপি"
  },

  // Countdown
  countdownDays: {
    en: "Days",
    bn: "দিন"
  },
  countdownHours: {
    en: "Hours",
    bn: "ঘন্টা"
  },
  countdownMinutes: {
    en: "Minutes",
    bn: "মিনিট"
  },
  countdownSeconds: {
    en: "Seconds",
    bn: "সেকেন্ড"
  },
  countdownUntil: {
    en: "Until We Say 'I Do'",
    bn: "যতক্ষণ না আমরা বলি 'কবুল'"
  },

  // Event Details Section
  eventTitle: {
    en: "Wedding Ceremony & Reception",
    bn: "বিবাহ অনুষ্ঠান ও রিসেপশন"
  },
  chapterOne: {
    en: "Chapter One",
    bn: "অধ্যায় ১"
  },
  dateTimeLabel: {
    en: "Date & Time",
    bn: "তারিখ ও সময়"
  },
  dateTime: {
    en: "3:00 PM · August 16, 2026",
    bn: "বিকাল ৩:০০ টা · ১৬ আগস্ট ২০২৬"
  },
  locationLabel: {
    en: "Location",
    bn: "স্থান"
  },
  location: {
    en: "3729 Lakeshore Road, Newcastle, Ontario",
    bn: "৩৭২৯ লেকশোর রোড, নিউক্যাসেল, অন্টারিও"
  },
  parkingLabel: {
    en: "Parking",
    bn: "পার্কিং"
  },
  parkingInfo: {
    en: "Parking available on site (limited) or on Riley Road.",
    bn: "সাইটে সীমিত পার্কিং আছে বা Riley Road-এ পার্ক করতে পারেন।"
  },
  noBoxedGiftsLabel: {
    en: "Gifts",
    bn: "উপহার"
  },
  noBoxedGifts: {
    en: "No boxed gifts, please",
    bn: "অনুগ্রহ করে বাক্সবন্দী উপহার নয়"
  },
  rsvpByLabel: {
    en: "RSVP By",
    bn: "আরএসভিপি শেষ তারিখ"
  },
  rsvpByDate: {
    en: "Please RSVP by August 5, 2026",
    bn: "অনুগ্রহ করে ৫ আগস্ট ২০২৬ এর মধ্যে RSVP করুন"
  },

  // Dress Code Section
  chapterTwo: {
    en: "Chapter Two",
    bn: "অধ্যায় ২"
  },
  dressCodeTitle: {
    en: "Suggested Attire",
    bn: "প্রস্তাবিত পোশাক"
  },
  dressCodeSubtitle: {
    en: "Lakeside Evening",
    bn: "লেকসাইড সন্ধ্যা"
  },
  dressCodeIntro: {
    en: "We're so excited to celebrate with you! Our wedding and reception will take place outdoors by the lake under a clear tent in the evening.\n\nWe warmly welcome both South Asian and Western formal attire for this celebration. Traditional attire, tuxedos, formal suits, and gowns are all beautifully suited for the occasion.\n\nThis is a dress-to-impress celebration — we cannot wait to see you looking your absolute best!",
    bn: "আপনাদের সাথে আমাদের এই বিশেষ দিনটি উদযাপন করতে পেরে আমরা সত্যিই আনন্দিত! আমাদের বিবাহ ও রিসেপশন অনুষ্ঠানটি লেকের ধারে, খোলা আকাশের নিচে একটি ক্লিয়ার টেন্টে, বিকেল থেকে সন্ধ্যা পর্যন্ত অনুষ্ঠিত হবে।\n\nএই অনুষ্ঠানে দক্ষিণ এশীয় ও পাশ্চাত্য—উভয় ধরনের ফরমাল পোশাক আন্তরিকভাবে স্বাগত। ঐতিহ্যবাহী পোশাক, টাক্সেডো, ফরমাল স্যুট অথবা গাউন — সবই এই অনুষ্ঠানের জন্য উপযুক্ত।\n\nএটি একটি \"ড্রেস-টু-ইমপ্রেস\" উদযাপন — আপনাদের সবার সেরা উপস্থিতি দেখার জন্য আমরা অধীর আগ্রহে অপেক্ষা করছি!"
  },
  attireTitle: {
    en: "Formal Attire in Rich Jewel Tones & Warm Metallics",
    bn: "সমৃদ্ধ জুয়েল টোন ও উষ্ণ মেটালিক রঙে ফরমাল পোশাক"
  },
  attireDescription: {
    en: "We warmly welcome both South Asian and Western formal attire for this celebration. Traditional attire, tuxedos, and formal suits / gowns are all beautifully suited for the occasion.\n\nGuests are invited to wear rich jewel tones and warm metallic hues that complement the lakeside setting and evening ambiance.",
    bn: "এই অনুষ্ঠানে দক্ষিণ এশীয় ও পাশ্চাত্য—উভয় ধরনের ফরমাল পোশাক আন্তরিকভাবে স্বাগত। ঐতিহ্যবাহী পোশাক, টাক্সেডো, ফরমাল স্যুট অথবা গাউন — সবই এই অনুষ্ঠানের জন্য উপযুক্ত।\n\nঅতিথিদের অনুরোধ করা হচ্ছে লেকসাইড পরিবেশ ও সন্ধ্যার আবহের সাথে মানানসই সমৃদ্ধ জুয়েল টোন ও উষ্ণ মেটালিক রঙ নির্বাচন করার জন্য।"
  },
  ladiesColorsTitle: {
    en: "Suggested Colour Palette for Ladies",
    bn: "মহিলাদের জন্য প্রস্তাবিত রঙসমূহ"
  },
  gentlemenColorsTitle: {
    en: "Suggested Colour Palette for Gentlemen",
    bn: "ভদ্রলোকদের জন্য প্রস্তাবিত রঙসমূহ"
  },
  avoidTitle: {
    en: "For the Ladies",
    bn: "মহিলাদের জন্য"
  },
  avoidDescription: {
    en: "We kindly ask that women avoid wearing red or white, as these colors are reserved for the bride.",
    bn: "আমরা মহিলাদের অনুরোধ করছি লাল বা সাদা রঙের পোশাক এড়িয়ে চলতে, কারণ এই রংগুলো কনের জন্য সংরক্ষিত।"
  },
  avoidItems: {
    en: [
      "Red in any shade or form, including suits, traditional attire, and accent pieces such as ties, bow ties, pocket squares, boutonnieres, jewelry or prominent design details",
      "Fully silver or predominantly silver-toned outfits",
      "Fully white or predominantly white attire"
    ],
    bn: [
      "লাল রঙের যেকোনো শেড বা ব্যবহার (স্যুট, ঐতিহ্যবাহী পোশাক, টাই, বো টাই, পকেট স্কোয়ার, বুটনিয়ার, গয়না বা স্পষ্ট ডিজাইন ডিটেইলসহ)",
      "সম্পূর্ণ রূপালি বা প্রধানত রূপালি রঙের পোশাক",
      "সম্পূর্ণ সাদা বা প্রধানত সাদা পোশাক"
    ]
  },
  gentleNote: {
    en: "We are thoughtfully curating a cohesive visual experience for our photography and videography. To preserve the overall aesthetic of the celebration, we kindly ask that all guests adhere to the dress code. Guests who are not within the requested color palette may not be included in certain formal portraits or professional video coverage.\n\nWe share this with love and appreciation — your understanding helps us protect the vision and timeless beauty of our day.",
    bn: "আমরা আমাদের ফটোগ্রাফি ও ভিডিওগ্রাফির জন্য একটি সুশৃঙ্খল ও সামঞ্জস্যপূর্ণ ভিজ্যুয়াল অভিজ্ঞতা তৈরি করছি। অনুষ্ঠানের সামগ্রিক নান্দনিকতা বজায় রাখতে, সকল অতিথিকে ড্রেস কোড অনুসরণ করার জন্য অনুরোধ করা হচ্ছে। নির্ধারিত রঙের বাইরে থাকা অতিথিরা কিছু আনুষ্ঠানিক ছবি বা পেশাদার ভিডিও কাভারেজে অন্তর্ভুক্ত নাও হতে পারেন।\n\nআমরা বিষয়টি ভালোবাসা ও কৃতজ্ঞতার সাথে জানাচ্ছি — আপনাদের সহযোগিতা আমাদের দিনের সৌন্দর্য ও স্বপ্নকে চিরন্তনভাবে ধরে রাখতে সহায়তা করবে।"
  },
  outdoorNote: {
    en: "As the celebration will take place outdoors by the lake, we recommend choosing footwear suitable for grass and bringing a light wrap for the evening breeze.\n\nWe are truly grateful to celebrate this special day with you and cannot wait to share an unforgettable lakeside evening together.\n\nIf you have any questions about attire, would like guidance or approval on your outfit, or need recommendations on where to shop for South Asian wear please feel free to reach out to us. We are more than happy to help.",
    bn: "অনুষ্ঠানটি লেকের ধারে খোলা পরিবেশে অনুষ্ঠিত হবে, তাই ঘাসের উপযোগী জুতা নির্বাচন এবং সন্ধ্যার হালকা ঠান্ডার জন্য একটি শাল বা হালকা ওড়না সঙ্গে রাখার পরামর্শ দেওয়া হচ্ছে।\n\nএই বিশেষ দিনে আপনাদের সাথে থাকতে পেরে আমরা আন্তরিকভাবে কৃতজ্ঞ। একটি স্মরণীয় লেকসাইড সন্ধ্যা একসাথে উদযাপন করার জন্য আমরা অধীর আগ্রহে অপেক্ষা করছি।\n\nপোশাক সম্পর্কে কোনো প্রশ্ন থাকলে, আপনার নির্বাচিত পোশাক সম্পর্কে মতামত বা অনুমোদন চাইলে, অথবা দক্ষিণ এশীয় পোশাক কোথা থেকে কিনবেন সে বিষয়ে পরামর্শ প্রয়োজন হলে, নির্দ্বিধায় আমাদের সাথে যোগাযোগ করুন। আমরা আনন্দের সাথে সহায়তা করতে প্রস্তুত।"
  },

  // RSVP Section
  chapterThree: {
    en: "Chapter Three",
    bn: "অধ্যায় ৩"
  },
  rsvpTitle: {
    en: "RSVP",
    bn: "আরএসভিপি"
  },
  rsvpSubtitle: {
    en: "We would be honored by your presence",
    bn: "আপনার উপস্থিতি আমাদের সম্মানিত করবে"
  },
  primaryGuestName: {
    en: "Your Full Name",
    bn: "আপনার পুরো নাম"
  },
  primaryGuestNamePlaceholder: {
    en: "Enter your full name",
    bn: "আপনার পুরো নাম লিখুন"
  },
  emailLabel: {
    en: "Email Address",
    bn: "ইমেইল ঠিকানা"
  },
  emailPlaceholder: {
    en: "your@email.com",
    bn: "your@email.com"
  },
  attendanceLabel: {
    en: "Will you be attending?",
    bn: "আপনি কি উপস্থিত থাকবেন?"
  },
  attendanceYes: {
    en: "Yes, I'll be there!",
    bn: "হ্যাঁ, আমি থাকব!"
  },
  attendanceNo: {
    en: "Sorry, I can't make it",
    bn: "দুঃখিত, আমি আসতে পারব না"
  },
  bringingGuestsLabel: {
    en: "Will you be bringing additional guests?",
    bn: "আপনি কি অতিরিক্ত অতিথি আনবেন?"
  },
  bringingGuestsYes: {
    en: "Yes",
    bn: "হ্যাঁ"
  },
  bringingGuestsNo: {
    en: "No, just me",
    bn: "না, শুধু আমি"
  },
  additionalGuestsLabel: {
    en: "Guest Names",
    bn: "অতিথিদের নাম"
  },
  addGuest: {
    en: "Add Another Guest",
    bn: "আরেকজন অতিথি যোগ করুন"
  },
  removeGuest: {
    en: "Remove",
    bn: "সরান"
  },
  guestNamePlaceholder: {
    en: "Guest full name",
    bn: "অতিথির পুরো নাম"
  },
  notesLabel: {
    en: "Notes (Optional)",
    bn: "নোট (ঐচ্ছিক)"
  },
  notesPlaceholder: {
    en: "Dietary restrictions, special requests, or a message for the couple...",
    bn: "খাদ্যতালিকাগত বিধিনিষেধ, বিশেষ অনুরোধ, অথবা দম্পতির জন্য বার্তা..."
  },
  submitRsvp: {
    en: "Submit RSVP",
    bn: "আরএসভিপি জমা দিন"
  },
  submitting: {
    en: "Submitting...",
    bn: "জমা হচ্ছে..."
  },
  rsvpThankYou: {
    en: "Thank you!",
    bn: "ধন্যবাদ!"
  },
  rsvpConfirmation: {
    en: "Your RSVP has been received.",
    bn: "আপনার RSVP গ্রহণ করা হয়েছে।"
  },
  rsvpConfirmationEmail: {
    en: "A confirmation email has been sent to your inbox.",
    bn: "আপনার ইনবক্সে একটি নিশ্চিতকরণ ইমেইল পাঠানো হয়েছে।"
  },
  rsvpDeclineMessage: {
    en: "We'll miss you! Thank you for letting us know.",
    bn: "আমরা আপনাকে মিস করব! জানানোর জন্য ধন্যবাদ।"
  },
  rsvpError: {
    en: "Something went wrong. Please try again.",
    bn: "কিছু ভুল হয়েছে। আবার চেষ্টা করুন।"
  },
  rsvpErrorEmail: {
    en: "Please enter a valid email address.",
    bn: "অনুগ্রহ করে একটি বৈধ ইমেইল ঠিকানা দিন।"
  },
  rsvpErrorName: {
    en: "Please enter your name.",
    bn: "অনুগ্রহ করে আপনার নাম লিখুন।"
  },
  rsvpErrorGuestName: {
    en: "Please enter all guest names or remove empty fields.",
    bn: "অনুগ্রহ করে সব অতিথির নাম লিখুন অথবা খালি ফিল্ড সরান।"
  },
  submitAnotherRsvp: {
    en: "Submit Another RSVP",
    bn: "আরেকটি RSVP জমা দিন"
  },

  // Footer
  madeWith: {
    en: "Made with love",
    bn: "ভালোবাসা দিয়ে তৈরি"
  },
  footerNames: {
    en: "Anica & Tamjid",
    bn: "আনিকা ও তামজিদ"
  },

  // Admin Page
  adminTitle: {
    en: "RSVP Responses",
    bn: "আরএসভিপি প্রতিক্রিয়া"
  },
  adminBackToSite: {
    en: "Back to Site",
    bn: "সাইটে ফিরুন"
  },
  adminRefresh: {
    en: "Refresh",
    bn: "রিফ্রেশ"
  },
  adminFamilies: {
    en: "Responses",
    bn: "প্রতিক্রিয়া"
  },
  adminTotalGuests: {
    en: "Total Guests",
    bn: "মোট অতিথি"
  },
  adminAttending: {
    en: "Attending",
    bn: "উপস্থিত"
  },
  adminNotAttending: {
    en: "Not Attending",
    bn: "অনুপস্থিত"
  },
  adminNoRsvps: {
    en: "No RSVPs Yet",
    bn: "এখনও কোনো RSVP নেই"
  },
  adminNoRsvpsDesc: {
    en: "RSVPs will appear here as guests respond.",
    bn: "অতিথিরা সাড়া দিলে RSVP এখানে দেখা যাবে।"
  },
  adminGuests: {
    en: "guests",
    bn: "অতিথি"
  },
  adminAddNote: {
    en: "Add Note",
    bn: "নোট যোগ করুন"
  },
  adminDelete: {
    en: "Delete",
    bn: "মুছুন"
  },
  adminDeleteConfirm: {
    en: "Delete this RSVP?",
    bn: "এই RSVP মুছবেন?"
  },
  adminYes: {
    en: "Yes",
    bn: "হ্যাঁ"
  },
  adminNo: {
    en: "No",
    bn: "না"
  },
  adminSave: {
    en: "Save",
    bn: "সংরক্ষণ"
  },
  adminCancel: {
    en: "Cancel",
    bn: "বাতিল"
  },
  adminLoading: {
    en: "Loading RSVPs...",
    bn: "RSVP লোড হচ্ছে..."
  },
  adminError: {
    en: "Failed to load RSVPs. Please try again.",
    bn: "RSVP লোড করতে ব্যর্থ। আবার চেষ্টা করুন।"
  },
  adminDismiss: {
    en: "Dismiss",
    bn: "বাতিল"
  },
  adminWillAttend: {
    en: "Will Attend",
    bn: "উপস্থিত থাকবেন"
  },
  adminWontAttend: {
    en: "Won't Attend",
    bn: "উপস্থিত থাকবেন না"
  },
  adminAdditionalGuests: {
    en: "Additional Guests",
    bn: "অতিরিক্ত অতিথি"
  }
};

// Color palettes for dress code
export const ladiesColors = [
  { name: { en: "Emerald", bn: "এমেরাল্ড" }, hex: "#50C878" },
  { name: { en: "Deep Teal", bn: "ডিপ টিল" }, hex: "#008080" },
  { name: { en: "Sapphire", bn: "স্যাফায়ার" }, hex: "#0F52BA" },
  { name: { en: "Royal Blue", bn: "রয়্যাল ব্লু" }, hex: "#4169E1" },
  { name: { en: "Amethyst", bn: "অ্যামেথিস্ট" }, hex: "#9966CC" },
  { name: { en: "Deep Plum", bn: "ডিপ প্লাম" }, hex: "#673147" },
  { name: { en: "Orchid", bn: "অর্কিড" }, hex: "#DA70D6" },
  { name: { en: "Rich Fuchsia", bn: "রিচ ফুশিয়া" }, hex: "#C154C1" },
  { name: { en: "Burnt Orange", bn: "বার্ট অরেঞ্জ" }, hex: "#CC5500" },
  { name: { en: "Antique Gold", bn: "অ্যান্টিক গোল্ড" }, hex: "#CFB53B" },
  { name: { en: "Champagne", bn: "শ্যাম্পেইন" }, hex: "#F7E7CE" }
];

export const gentlemenColors = [
  { name: { en: "Black", bn: "ব্ল্যাক" }, hex: "#000000" },
  { name: { en: "Midnight Blue", bn: "মিডনাইট ব্লু" }, hex: "#191970" },
  { name: { en: "Charcoal", bn: "চারকোল" }, hex: "#36454F" },
  { name: { en: "Navy", bn: "নেভি" }, hex: "#000080" },
  { name: { en: "Deep Slate", bn: "ডিপ স্লেট" }, hex: "#2F4F4F" },
  { name: { en: "Forest Green", bn: "ফরেস্ট গ্রিন" }, hex: "#228B22" },
  { name: { en: "Deep Teal", bn: "ডিপ টিল" }, hex: "#008080" },
  { name: { en: "Dark Olive", bn: "ডার্ক অলিভ" }, hex: "#556B2F" },
  { name: { en: "Graphite", bn: "গ্রাফাইট" }, hex: "#383838" },
  { name: { en: "Cobalt", bn: "কোবাল্ট" }, hex: "#0047AB" }
];

export const avoidColors = [
  { name: { en: "Red", bn: "লাল" }, hex: "#FF0000" },
  { name: { en: "Silver", bn: "রূপালি" }, hex: "#C0C0C0" },
  { name: { en: "White", bn: "সাদা" }, hex: "#FFFFFF" }
];
